// StreamerProfile.jsx
import React from 'react';
import { Outlet, useParams, Link, useLocation } from 'react-router-dom';
import Breadcrums from '../../common/breadcrumbs';
import { useTranslation } from "react-i18next";

const StreamerProfile = (props) => {
    const { t } = useTranslation();
    const params = useParams();
    const location = useLocation();
    
    const breadcrumbs = [
        { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
        { title: t("label_edit_streamer_details"), url: "/admin/streamers/list/1" },
        { title: t("btn_edit"), url: "" },
    ];

    const isEditProfileTab = location.pathname === `/admin/streamers/edit/${params?.id}` || 
                             location.pathname.includes('/edit-profile');
    const isBusinessProfileTab = location.pathname.includes('/business-profile');
    const isKYCTab = location.pathname.includes('/kyc-information');
    const isSocialMediaTab = location.pathname.includes('/social-media');

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                    <div className="card custom-card">
                        <div className="card-body">
                            <div className="tabs-wrap">
                                <div className="profile-tab tab-menu-heading mb-4">
                                    <nav className="nav main-nav-line p-3 tabs-menu profile-nav-line bg-gray-100">
                                        <Link 
                                            to={`/admin/streamers/edit/${params?.id}/edit-profile`}
                                            className={"nav-link linkactive" + (isEditProfileTab ? " active" : "")}>
                                            {t("Edit Profile")}
                                        </Link>
                                        <Link 
                                            to={`/admin/streamers/edit/${params?.id}/business-profile`}
                                            className={"nav-link linkactive" + (isBusinessProfileTab ? " active" : "")}>
                                            {t("Business Profile")}
                                        </Link>
                                        <Link 
                                            to={`/admin/streamers/edit/${params?.id}/kyc-information`}
                                            className={"nav-link linkactive" + (isKYCTab ? " active" : "")}>
                                            {t("KYC Information")}
                                        </Link>
                                    </nav>
                                </div>
                                <Outlet />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default StreamerProfile;